import type { GuidelineDraftRule } from '../types/accuracy';

export const RULE_TYPE_OPTIONS = [
  { value: 'text_check', label: 'テキストチェック' },
  { value: 'forbidden_regular_expression_check', label: '禁止表現チェック' },
  { value: 'musthave_regular_expression_check', label: '必須表現チェック' },
  { value: 'forbidden_image', label: '禁止画像チェック' },
  { value: 'required_image_match', label: '必要画像一致チェック' },
];

export const PATROL_SOURCE_OPTIONS = [
  { value: 'all_page', label: 'ページ全体' },
  { value: 'page_chunk', label: 'ページのチャンク単位' },
];

export function getRuleTypeLabel(type?: string | null): string {
  return RULE_TYPE_OPTIONS.find((o) => o.value === type)?.label ?? type ?? 'テキストチェック';
}

export function shouldShowRuleField(rule: GuidelineDraftRule, fieldName: string): boolean {
  const ruleType = rule.type || 'text_check';

  if (fieldName === 'patrol_source') {
    return (
      ruleType === 'text_check' ||
      ruleType === 'forbidden_regular_expression_check' ||
      ruleType === 'musthave_regular_expression_check'
    );
  }
  if (fieldName === 'violation_check_prompt' || fieldName === 'existence_check_prompt') {
    return ruleType === 'text_check';
  }
  if (fieldName === 'forbidden_regular_expressions' || fieldName === 'forbidden_detect_message') {
    return ruleType === 'forbidden_regular_expression_check';
  }
  if (fieldName === 'musthave_regular_expressions' || fieldName === 'musthave_not_detect_message') {
    return ruleType === 'musthave_regular_expression_check';
  }
  if (fieldName === 'regular_expression_conditions') {
    return (
      ruleType === 'forbidden_regular_expression_check' ||
      ruleType === 'musthave_regular_expression_check'
    );
  }
  return false;
}

export function applyRuleTypeChange(rule: GuidelineDraftRule, newType: string): GuidelineDraftRule {
  const updated: GuidelineDraftRule = { ...rule, type: newType };
  if (newType === 'text_check') {
    delete updated.forbidden_regular_expressions;
    delete updated.forbidden_detect_message;
    delete updated.musthave_regular_expressions;
    delete updated.musthave_not_detect_message;
    delete (updated as any).forbidden_image_assets;
    if (!updated.patrol_source) updated.patrol_source = 'all_page';
  } else if (newType === 'forbidden_regular_expression_check') {
    delete updated.violation_check_prompt;
    delete updated.existence_check_prompt;
    delete updated.musthave_regular_expressions;
    delete updated.musthave_not_detect_message;
    if (!updated.forbidden_regular_expressions?.length) {
      updated.forbidden_regular_expressions = [''];
    }
    if (!updated.patrol_source) updated.patrol_source = 'all_page';
  } else if (newType === 'musthave_regular_expression_check') {
    delete updated.violation_check_prompt;
    delete updated.existence_check_prompt;
    delete updated.forbidden_regular_expressions;
    delete updated.forbidden_detect_message;
    if (!updated.musthave_regular_expressions?.length) {
      updated.musthave_regular_expressions = [''];
    }
    if (!updated.patrol_source) updated.patrol_source = 'all_page';
  } else if (newType === 'forbidden_image') {
    delete updated.violation_check_prompt;
    delete updated.existence_check_prompt;
    delete updated.forbidden_regular_expressions;
    delete updated.forbidden_detect_message;
    delete updated.musthave_regular_expressions;
    delete updated.musthave_not_detect_message;
    delete updated.regular_expression_conditions;
    delete updated.patrol_source;
  } else if (newType === 'required_image_match') {
    delete updated.violation_check_prompt;
    delete updated.existence_check_prompt;
    delete updated.forbidden_regular_expressions;
    delete updated.forbidden_detect_message;
    delete updated.musthave_regular_expressions;
    delete updated.musthave_not_detect_message;
    delete updated.regular_expression_conditions;
    delete updated.patrol_source;
    delete (updated as any).forbidden_image_assets;
  }
  return updated;
}